export default __webpack_public_path__ + "static/media/SaraElizabetDill.052e05aa.jpg";